import config from 'config';

const SAVE_LOAD_SUBSCRIPTIONS = 'userService/selections/SAVE_LOAD_SUBSCRIPTIONS';
const SAVE_LOAD_SUBSCRIPTIONS_SUCCESS = 'userService/selections/SAVE_LOAD_SUBSCRIPTIONS_SUCCESS';
const SAVE_LOAD_SUBSCRIPTIONS_FAIL = 'userService/selections/SAVE_LOAD_SUBSCRIPTIONS_FAIL';

const DELETE_SUBSCRIPTIONS = 'userService/selections/DELETE_SUBSCRIPTIONS';
const DELETE_SUBSCRIPTIONS_SUCCESS = 'userService/selections/DELETE_SUBSCRIPTIONS_SUCCESS';
const DELETE_SUBSCRIPTIONS_FAIL = 'userService/selections/DELETE_SUBSCRIPTIONS_FAIL';

const RESET_SUBSCRIPTIONS = 'userService/subscriptions/RESET_SUBSCRIPTIONS';

const initialState = {
  loading: false,
  loaded: false,
  subscriptions: {}
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case SAVE_LOAD_SUBSCRIPTIONS:
      return {
        ...state,
        loading: true
      };
    case SAVE_LOAD_SUBSCRIPTIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        subscriptions: mergeSubscriptions(state.subscriptions, action.result.subscription)
      };
    case SAVE_LOAD_SUBSCRIPTIONS_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error.body,
        status: action.error.status
      };
    case DELETE_SUBSCRIPTIONS:
      return {
        ...state
      };
    case DELETE_SUBSCRIPTIONS_SUCCESS:
      return {
        ...state,
        subscriptions: removeSubscriptions(state.subscriptions, action.subscription)
      };
    case DELETE_SUBSCRIPTIONS_FAIL:
      return {
        ...state,
        error: action.error.body,
        status: action.error.status
      };
    case RESET_SUBSCRIPTIONS:
      return initialState;
    default:
      return state;
  }
}

function mergeSubscriptions(stateSubscriptions = {}, flatSubscriptions = []) {
  const structuredSubs = {...stateSubscriptions};

  flatSubscriptions.forEach(subscription => {
    const {
      user_subscription_id: subId,
      subscription_id: id,
      subscription_type: type,
      display_text: text
    } = subscription;

    if (!structuredSubs[type]) {
      structuredSubs[type] = {}
    }
    structuredSubs[type][id] = { text, subId };
  });

  return structuredSubs;
}

function removeSubscriptions(stateSubscriptions = {}, flatSubscriptions = []) {
  const removableSubs = {...stateSubscriptions};

  flatSubscriptions.forEach(subscription => {
    const {
      id,
      type
    } = subscription;

    if (removableSubs[type] && removableSubs[type][id]) {
      delete removableSubs[type][id];
    }
  });

  return removableSubs;
}

export function loadSubscriptions(auth) {
  return {
    types: [SAVE_LOAD_SUBSCRIPTIONS, SAVE_LOAD_SUBSCRIPTIONS_SUCCESS, SAVE_LOAD_SUBSCRIPTIONS_FAIL],
    promise: (client) => client.post(
      config.api.common.userService.loadSubscriptions,
      { data: loadSubscriptionsTemplate(auth) },
      { Authorization: auth.user.ssoToken }
    )
  };
}

export function saveSubscriptions(auth, subscription) {
  return {
    types: [SAVE_LOAD_SUBSCRIPTIONS, SAVE_LOAD_SUBSCRIPTIONS_SUCCESS, SAVE_LOAD_SUBSCRIPTIONS_FAIL],
    promise: (client) => client.post(
      config.api.common.userService.saveSubscriptions,
      { data: saveSubscriptionsTemplate(auth, subscription) },
      { Authorization: auth.user.ssoToken }
    )
  };
}

export function deleteSubscriptions({ user: { ssoToken } = {} }, subscriptions) {
  return {
    types: [DELETE_SUBSCRIPTIONS, DELETE_SUBSCRIPTIONS_SUCCESS, DELETE_SUBSCRIPTIONS_FAIL],
    promise: (client) => Promise.all(subscriptions.map(({ subId = 0 }) =>
      client.del(`${ config.api.common.userService.deleteSubscriptions }/${ subId }`, {}, { Authorization: ssoToken })
    )),
    subscription: subscriptions
  };
}

export function resetSubscriptions() {
  return {
    type: RESET_SUBSCRIPTIONS
  }
}

function loadSubscriptionsTemplate({ user }) {
  if (user) {
    return {
      user: {
        user_reference: {
          external_reference: [{ref: 'skybet', value: user.customerId}]
        },
        email: user.email,
        roles: [{name:'PUNTER'}]
      },
      filter: ['HORSE', 'JOCKEY', 'TRAINER', 'RACE', 'FOOTBALL_MATCH']
    }
  }
  return {}
}

function saveSubscriptionsTemplate({ user, deviceId }, subscriptions) {
  if (user) {
    return {
      user: {
        user_reference: {
          external_reference: [{ref: 'skybet', value: user.customerId}]
        },
        email: user.email,
        roles: [{name: 'PUNTER'}],
        devices: [{push_id: deviceId}]
      },
      subscription: subscriptions.map(sub => ({
        subscription_id: sub.id,
        subscription_type: sub.type,
        display_text: sub.text
      }))
    }
  }
  return {}
}

export function userServiceLayoutConnect({state, then} = {}) {
  const connectSpec = {
    dispatch: ({auth}) => loadSubscriptions(auth),
    preventResolve: ({state, loggedIn}) => (!loggedIn || !!state.common.userService.loading)
  };

  if (state) {
    connectSpec.state = state;
  }

  if (then) {
    connectSpec.then = then;
  }

  return connectSpec;
}



// WEBPACK FOOTER //
// ./modules/Common/reducers/userService.js